import React from 'react';
import styled from 'styled-components';
import {FilterDrawerDateRange} from '../../tickets/components/FilterDrawerDateRange';

interface Props {
	from: string;
	to: string;
	onChangeFrom: (value: string) => void;
	onChangeTo: (value: string) => void;
}

const Wrapper = styled.div`
	max-width: 420px;
	margin-bottom: 24px;
`;

export function DashboardPeriodPicker({from, to, onChangeFrom, onChangeTo}: Props) {
	return (
		<Wrapper>
			<FilterDrawerDateRange label="Period" from={from} to={to} onChangeFrom={onChangeFrom} onChangeTo={onChangeTo} />
		</Wrapper>
	);
}
